import state from "./state";
import mutations from "./mutations";
import getters from "./getters";
import actions from "./actions";
// import * as types from "./types";

export default {
  namespaced: true,
  state: state(),
  mutations,
  getters,
  actions,
  // types,
};
